module.exports = __webpack_public_path__ + "img/close_button.eb55dd6f.png";